import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonApiService } from '../CommonController/common-api-service';
import { DeviceModelApiService } from '../CommonController/device-model-api-service';
import { MatIcon } from '@angular/material/icon';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-model-page',
  templateUrl: './model-page.component.html',
  styleUrls: ['./model-page.component.scss'],
  standalone: true,
  imports: [
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
    NgxPaginationModule,
  ],
})
export class ModelPageComponent implements OnInit {
  // Pagination settings
  pageSize = 10; // Number of items per currentPage
  currentPage = 1; // Current currentPage
  totalItems = 0; // Total number of items (for pagination purposes)
  searchText = ''; // Search text
  modelList = [];

  userPermission = [];
  ModelFirmwareView = false;
  ModelFirmwareCreate = false;
  ModelFirmwareDelete = false;
  ModelFirmwareUpdate = false;
  loggedId = '';

  constructor(
    public deviceModelApiService: DeviceModelApiService,
    public commonApiService: CommonApiService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    // Resetting the page
    this.pageSize = 10; // Number of items per currentPage
    this.currentPage = 1; // Current currentPage
    this.totalItems = 0; // Total number of items (for pagination purposes)
    this.modelList = [];
    this.fetchModelList();
  }

  checkPermission() {
    this.loggedId = sessionStorage.getItem('loggedInUserId');
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermissions'));
    this.userPermission.forEach((element) => {
      if (element.pageName === 'Model' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Model' && element.view === true) {
        this.ModelFirmwareView = true;
      }
      if (element.pageName === 'Model' && element.update === true) {
        this.ModelFirmwareUpdate = true;
      }
      if (element.pageName === 'Model' && element.create === true) {
        this.ModelFirmwareCreate = true;
      }
      if (element.pageName === 'Model' && element.delete === true) {
        this.ModelFirmwareDelete = true;
      }
    });
  }

  fetchModelList() {
    this.spinner.show();
    this.deviceModelApiService
      .getDeviceModelList(this.currentPage, this.pageSize, this.searchText)
      .subscribe({
        next: (res) => {
          this.modelList = res.data;
          this.totalItems = res.totalItems;
          this.commonApiService.openSnackbar(res.message);
          this.spinner.hide();
        },
        error: (error) => {
          this.spinner.hide();
          if (error.status === 404) {
            this.modelList = []; // Clear the list
            this.totalItems = 0; // Reset the total count
            // this.currentPage = 0;
            this.currentPage = 1;
            // this.currentPage = this.currentPage + 1;
            this.commonApiService.openSnackbar(error.error.message);
          } else {
            this.commonApiService.openSnackbar(
              'An error occurred while fetching data.'
            );
          }
        },
      });
  }

  onPageChange(event) {
    this.currentPage = event;
    this.fetchModelList();
  }

  onSearchInputChange(event) {
    this.currentPage = 1;
    this.searchText = event;
    this.fetchModelList();
  }

  onSizeChange(newSize): void {
    this.pageSize = newSize; // Update the pageSize
    this.currentPage = 1; // Reset to the first currentPage
    this.fetchModelList();
  }

  prePopulation(id) {
    this.router.navigate(['model-firmware', id]);
  }

  delete(modelId) {
    const userId = this.loggedId; // Hardcoded userId
    if (confirm('Are you sure? Do you want to delete')) {
      this.spinner.show();
      this.deviceModelApiService
        .deleteDeviceModelById(modelId, userId)
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.commonApiService.openSnackbar(res.message);
              this.spinner.hide();
              this.ngOnInit();
            } else {
              this.spinner.hide();
              this.commonApiService.openSnackbar('Operation Failed');
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            this.commonApiService.openSnackbar(ERROR.error.message);
          },
        });
    }
  }

  AddNew() {
    this.router.navigate(['model-firmware']);
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
